import React, { Component } from 'react';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import SvgViewer from '../../../customComponents/svgViewer';
import { DeleteIcon } from '../../../svgIcons';
import { BasicLazyParams } from '../../../../utile';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import LoadingComponent from '../../../loadingComponent';
import AddTemplate from './addEmailTemplate';
import { ConfirmDialog } from 'primereact/confirmdialog';

export default class EmailTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            globalFilter: "",
            isShowAdd: false,
            columns: [
                { field: 'name', header: 'Name', show: true },
                { field: 'subject', header: 'Subject', show: true },
                { field: 'body', header: 'Body', show: true },
                { field: 'actions', header: 'Edit', show: true }
            ],
            lazyParams: BasicLazyParams,
            globalSearch: '',
            isLoading: false,
            totalRecords: 0,
            showSearch: false,
            editTemplate: null
        }
        this.service = new Service();
    }

    isShowEdit = (rowData) => {
        this.setState({
            isShowAdd: true,
            editTemplate: rowData
        })
    }

    getTemplates = () => {
        this.setState({
            isLoading: true,
            templates: [],
            totalRecords: 0
        });
        let { lazyParams, globalSearch } = this.state;
        let url = `${baseUrlAdmin}/emailtemplate?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`;

        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    templates: res.res.data.templates,
                    totalRecords: res.res.data.totalRecords,
                    isLoading: false
                });
            } else {
                this.setState({
                    isLoading: false,
                    templates: [],
                    totalRecords: 0
                });
            }
        }).catch(e => {
            console.error('Error fetching email templates:', e);
            this.setState({
                isLoading: false,
                templates: [],
                totalRecords: 0
            });
        })
    }

    onGlobalSearch = (e) => {
        this.setState((prevState) => ({
            ...prevState,
            globalSearch: e.target.value,
            lazyParams: {
                ...prevState.lazyParams,
                first: 0,
                page: 0
            }
        }), this.getTemplates);
    }

    onPage = (event) => {
        this.setState((prevState) => ({
            ...prevState,
            lazyParams: event
        }), this.getTemplates);
    }

    onSort = (event) => {
        this.setState((prevState) => ({
            ...prevState,
            lazyParams: event
        }), this.getTemplates);
    }

    onFilter = (event) => {
        event['first'] = 0;
        this.setState((prevState) => ({
            ...prevState,
            lazyParams: event
        }), this.getTemplates);
    }

    handleDelete = (rowData) => {
        confirmDialog({
            message: `Are you sure you want to delete the template "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                let url = `${baseUrlAdmin}/emailtemplate/${rowData._id}`;
                this.service.delete(url, true).then(res => {
                    if (res && res.status && res.res.status) {
                        this.getTemplates();
                        this.toast.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Template deleted successfully'
                        });
                    } else {
                        this.toast.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: res.errMessage || 'Failed to delete template'
                        });
                    }
                }).catch(e => {
                    console.error('Error deleting template:', e);
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete template'
                    });
                });
            },
            reject: () => {
                // Do nothing on reject
            }
        });
    }

    componentDidMount() {
        this.getTemplates();
    }

    onCreateOrEditSuccess = () => {
        this.setState({
            isShowAdd: false,
            editTemplate: null
        }, this.getTemplates);
    }

    attachmentTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="flex align-items-center">
                {rowData.attachment ? (
                    <i className="pi pi-check text-green-500" title="Has attachment"></i>
                ) : (
                    <i className="pi pi-times text-red-500" title="No attachment"></i>
                )}
            </div>
        );
    };

    editTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="flex align-items-center gap-2">
                <span data-pr-tooltip="Edit Template" data-pr-position="bottom" className={`e1${rowIndex}`} onClick={() => {
                    this.isShowEdit(rowData);
                }}>
                    <SvgViewer className='ma-icon-svg ma-pointer' src='new-assets/edit.svg' width="20" height="20" />
                </span>
                <Tooltip className="table-li-tooltip" autoHide={false} target={`.e1${rowIndex}`} />

                <span data-pr-tooltip="Delete Template" data-pr-position="bottom" className={`dlete${rowIndex} ma-mlr10`}
                    onClick={() => {
                        this.handleDelete(rowData);
                    }}
                >
                    <DeleteIcon height={20} width={20} />
                </span>
                <Tooltip className="table-li-tooltip" target={`.dlete${rowIndex}`} />
            </div>
        );
    }

    render() {
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex align-items-center">
                    <h4 className="m-0">Template Management</h4>
                    {this.state.showSearch && <InputText placeholder="Search" className="ml-4 h-2rem w-15rem" onChange={this.onGlobalSearch} />}
                </div>

                <div className="flex align-items-center gap-2">
                    <Button
                        label="Add Template"
                        icon="pi pi-plus"
                        className="p-button-primary"
                        onClick={() => this.setState({ isShowAdd: true, editTemplate: null })}
                    />
                </div>
            </div>
        );

        return (
            <div className="email-templates-container">
                <Toast ref={(el) => this.toast = el} />
                <ConfirmDialog />

                {this.state.isLoading && <LoadingComponent />}

                <DataTable
                    ref={(el) => this.dt = el}
                    value={this.state.templates}
                    lazy
                    paginator
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    onPage={this.onPage}
                    onSort={this.onSort}
                    onFilter={this.onFilter}
                    loading={this.state.isLoading}
                    first={this.state.lazyParams.first}
                    sortField={this.state.lazyParams.sortField}
                    sortOrder={this.state.lazyParams.sortOrder}
                    filters={this.state.lazyParams.filters}
                    header={header}
                    emptyMessage="No email templates found"
                    className="p-datatable-sm"
                    responsiveLayout="scroll"
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} templates"
                >
                    <Column field="name" header="Name" sortable />
                    <Column field="subject" header="Subject" sortable />
                    <Column field="body" header="Body" sortable />
                    <Column field="attachment" header="Attachment" body={this.attachmentTemplate} style={{ width: '8rem' }} />
                    <Column header="Edit" body={this.editTemplate} style={{ width: '8rem' }} />
                </DataTable>

                <Dialog
                    visible={this.state.isShowAdd}
                    style={{ width: '50vw' }}
                    header={this.state.editTemplate ? 'Edit Email Template' : 'Add Email Template'}
                    modal
                    onHide={() => this.setState({ isShowAdd: false, editTemplate: null })}
                >
                    <AddTemplate
                        editTemplate={this.state.editTemplate}
                        hideAddTemplateDialog={() => {
                            this.setState({
                                editTemplate: null,
                                isShowAdd: false
                            })
                        }}
                        onCreateOrEditSuccess={this.onCreateOrEditSuccess}
                        orgId={this.props.orgId}
                    />
                </Dialog>
            </div>
        )
    }
}
